const filterSumoSelectConfig = {
  placeholder: "Vyberte",
  captionFormat: "Vybrané položky: {0}",
  captionFormatAllSelected: "Všetky",
  locale: ["OK", "Zrušiť", "Vybrať všetky"],
}

export default filterSumoSelectConfig
